import React from 'react';
import type { IconProps } from '../types';

const PatientStudyList = (props: IconProps) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#patient-study-list_svg__a)">
      <path
        d="M0.6875 8.9375V4.8125C0.6875 3.71848 1.1221 2.66927 1.89568 1.89568 2.66927 1.1221 3.71848 0.6875 4.8125 0.6875H8.9375"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3125 8.9375V4.8125C32.3125 3.71848 31.8779 2.66927 31.1043 1.89568 30.3307 1.1221 29.2815 0.6875 28.1875 0.6875H24.0625"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.6875 24.0625V28.1875C0.6875 29.2815 1.1221 30.3307 1.89568 31.1043 2.66927 31.8779 3.71848 32.3125 4.8125 32.3125H8.9375"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3125 24.0625V28.1875C32.3125 29.2815 31.8779 30.3307 31.1043 31.1043 30.3307 31.8779 29.2815 32.3125 28.1875 32.3125H24.0625"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.4436 26.2446C7.79153 24.8832 10.2891 23.798 12.8865 23.0106 14.0374 22.5844 14.1625 19.9458 13.3375 19.0369 12.1467 17.7279 11.1375 16.192 11.1375 12.485 11.0681 11.7465 11.1563 11.0017 11.3962 10.2997 11.6361 9.59783 12.0223 8.95483 12.5291 8.41325 13.036 7.87167 13.6521 7.44384 14.3366 7.15806 15.0211 6.87227 15.7585 6.73502 16.5 6.7554 17.2415 6.73502 17.9789 6.87227 18.6634 7.15806 19.3479 7.44384 19.9639 7.87167 20.4708 8.41325 20.9777 8.95483 21.3639 9.59783 21.6038 10.2997 21.8437 11.0017 21.9318 11.7465 21.8625 12.485 21.8625 16.1975 20.8532 17.7279 19.6625 19.0369 18.8375 19.9458 18.9626 22.5844 20.1135 23.0106 22.7109 23.798 25.2084 24.8832 27.5564 26.2446"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="patient-study-list_svg__a">
        <rect
          width={33}
          height={33}
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
);

export default PatientStudyList;
